import { createI18n } from 'vue-i18n'

// Import translation files
import en from '../locales/en.json'
import es from '../locales/es.json'
import fr from '../locales/fr.json'
import de from '../locales/de.json'

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('language') || 'en'

// Create and export the I18n instance
const i18n = createI18n({
  legacy: false,
  locale: savedLanguage, // Use saved language or default to 'en'
  fallbackLocale: 'en', // Fallback language
  messages: {
    en,
    es,
    fr,
    de,
  },
})

export default i18n
